import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "antd/dist/reset.css"; // Ant Design base styles
import './index.css'
import { ConfigProvider, App as AntApp } from "antd";
import { StyleProvider } from "@ant-design/cssinjs";
import { theme } from "./theme.js";

import { Provider } from "react-redux";
import { store } from "./store/store.js";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider theme={theme}>
        <AntApp>
          <StyleProvider hashPriority="high">
            <App />
          </StyleProvider>
        </AntApp>
      </ConfigProvider>
    </Provider>
  </React.StrictMode>
);
